import { Empty, Radio, RadioChangeEvent, Space } from "antd";
import { useState } from "react";

type RadioInputProps = {
	disabled?: boolean;
	initialValue?: string;
	onChange: (value: string) => void;
	options: string[];
	questionText?: string;
	optionLabelMap?: Record<string, string>;
	hasError?: boolean;
	addDefaultValue?: string;
	onAddDefault?: () => void;
};

const RadioInput = ({
	disabled = false,
	initialValue,
	onChange,
	options,
	optionLabelMap = {},
	hasError = false,
	addDefaultValue,
	onAddDefault
}: RadioInputProps) => {
	const hasDefault = addDefaultValue != null && onAddDefault != null;
	const [value, setValue] = useState<string | undefined>(hasDefault ? undefined : initialValue);

	const handleChange = (e: RadioChangeEvent) => {
		setValue(e.target.value);
		onChange(e.target.value);
	};

	const handleAddDefault = () => {
		if (addDefaultValue != null && onAddDefault != null) {
			setValue(addDefaultValue);
			onAddDefault();
		}
	};

	if (options.length > 0) {
		return (
			<div className={hasError ? "edc-radio-error" : ""}>
				<div className="flex flex-wrap items-center gap-2">
					<Radio.Group
						disabled={disabled}
						value={value}
						onChange={handleChange}>
						<Space direction="vertical">
							{options.map((option, index) => (
								<Radio key={index} value={option}>
									{optionLabelMap[option] || option}
								</Radio>
							))}
						</Space>
					</Radio.Group>
					{hasDefault && (
						<span
							role="button"
							tabIndex={0}
							onClick={(e) => {
								e.preventDefault();
								handleAddDefault();
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter" || e.key === " ") {
									e.preventDefault();
									handleAddDefault();
								}
							}}
							className="cursor-pointer text-indigo-600 hover:text-indigo-700 whitespace-nowrap">
							Add default
						</span>
					)}
				</div>
			</div>
		);
	}

	return (
		<div className="rounded-xl border border-dashed border-red-300 bg-red-50 py-4 flex flex-col items-center gap-2">
			<Empty description={false} />
			<p className="text-sm text-red-500 font-medium">Add more travellers to answer this question</p>
		</div>
	);
};

export default RadioInput;

